import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ResetPasswordRequest, ResetPasswordResponse } from '../models/reset-password.model';
import { ResetPasswordTokenResponse } from '../models/reset-password-token.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  private readonly API_URL = '/user';
  private apiService = inject(ApiService);


  resetPassword(token: string, request: ResetPasswordRequest): Observable<ResetPasswordResponse> {
    return this.apiService
      .put<ResetPasswordResponse>(
        `${this.API_URL}/reset-password/update/${token}`,
        request
      )
      .pipe(
        tap(response => {
          if (response.status === 'success') {
            console.log('Senha alterada com sucesso');
          } else {
            console.error('Erro ao alterar senha:', response.status);
          }
        })
      );
  }

  validateToken(token: string): Observable<ResetPasswordTokenResponse> {
    return this.apiService
    .get<ResetPasswordTokenResponse>(
      `${this.API_URL}/reset-password/validate/${token}`
    )
    .pipe(
      tap(response => {
        if (response.status === 'success') {
          console.log('Token valido');
        } else {
          console.error('Token invalido ou não existe:', response.status);
        }
      })
    );
  }
}
